import { render } from "./TeamingTextbox.vue?vue&type=template&id=8c500830&scoped=true"
import script from "./TeamingTextbox.vue?vue&type=script&lang=js"
export * from "./TeamingTextbox.vue?vue&type=script&lang=js"

import "./TeamingTextbox.vue?vue&type=style&index=0&id=8c500830&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c500830"

export default script